import { Link } from '@remix-run/react'

export default function RegistrationRoute() {
	return (
		<main>
			<div className="relative isolate overflow-hidden bg-stone-900">
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="mx-auto mt-24 max-w-7xl px-6 pb-24 pt-10 sm:pb-32 lg:mt-0 lg:flex lg:items-center lg:px-8 lg:py-40">
					<div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl lg:lg:pt-8">
						<div className="inline-flex space-x-3">
							<span className="rounded-full bg-stone-100/10 px-3 py-1 text-sm font-semibold leading-6 text-stone-100">
								35th Season
							</span>
							<span className="inline-flex items-center space-x-2 text-sm font-medium leading-6 text-stone-300">
								<span>2026-27</span>
							</span>
						</div>
						<h3 className="mt-6 text-4xl font-extrabold uppercase leading-6 tracking-wide text-white md:text-6xl lg:text-7xl xl:text-8xl">
							<span className="text-[#f9c04d]">Get</span>
							{/* <span className="text-[#f9c04d]">.</span> */}
						</h3>
						<h3 className="text-4xl font-extrabold uppercase tracking-wide text-white md:text-6xl lg:text-7xl xl:text-8xl">
							Registered
						</h3>

						<p className="text-3xl font-extrabold leading-6 text-[#f9c04d] md:text-4xl lg:mr-24 lg:text-right xl:mr-0">
							don't miss out
							<span className="text-stone-100">.</span>
						</p>
					</div>
					<div className="mx-auto mt-16 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32">
						<div className="max-w-3xl flex-none sm:max-w-5xl lg:max-w-none">
							<div className="-m-2 rounded-xl p-2 lg:-m-4 lg:rounded-2xl lg:p-4">
								<img
									src="/images/reg-banner.jpg"
									alt="Studio Students"
									width={2432}
									height={1442}
									className="w-[56rem] rounded-md shadow-2xl ring-1 ring-gray-900/10"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="relative isolate overflow-hidden border-t-2 border-stone-800 bg-stone-900 pb-12">
				<div className="mx-auto max-w-7xl px-6 py-24 lg:px-8">
					<div className="space-x-8 md:grid md:grid-cols-6 md:items-start md:justify-start">
						<div className="pb-8 text-4xl font-extrabold text-stone-50 md:col-span-2 md:pb-0 md:text-6xl lg:text-7xl xl:text-8xl">
							Our <span className="text-[#f9c04d]">35th</span> Season
							<span className="text-[#f9c04d]">.</span>
						</div>
						<div className="space-y-4 text-lg font-bold tracking-wide text-stone-200 md:col-span-4">
							<p>
								Welcome to our 35th Season of Dance Excellence! Class placement
								decisions are derived from many years of teaching experience.
								Stage Door Dance Academy reserves the right to place students in
								the appropriate class level. If you have any questions before
								registering, please do not hesitate to call or email us! We look
								forward to dancing with you this season!
							</p>
							<p className="text-base">
								<span className="italic text-[#f9c04d]">
									Season 35 is September 8, 2026 – June 6, 2027
								</span>{' '}
							</p>
						</div>
					</div>
				</div>
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
			</div>
			<div className="relative isolate overflow-hidden border-t-2 border-stone-800 bg-stone-900 pb-12">
				<div className="mx-auto max-w-7xl px-6 py-24 lg:px-8">
					<h2 className="text-center text-4xl font-bold tracking-tight text-white md:text-6xl lg:text-7xl xl:text-8xl">
						Registration is <span className="text-[#f9c04d]">easy</span>!
					</h2>
					<p className="mx-auto mt-6 max-w-2xl text-lg font-bold leading-8 text-stone-200">
						Simply click the link below to register for classes. If you have any
						questions, please do not hesitate to call or email us!
					</p>
					<div className="mt-10 flex items-center justify-center gap-x-6">
						<a
							href="https://clients.dancestudiomanager.com/sdda/client/"
							target="_blank"
							rel="noreferrer"
							className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
						>
							Registration Portal
						</a>
					</div>
				</div>
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
			</div>
			<div
				id="details"
				className="relative isolate overflow-hidden border-t-2 border-stone-800 bg-stone-900 pb-12"
			>
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="mx-auto max-w-7xl px-6 py-24 lg:px-8">
					<h2 className="text-center text-4xl font-bold tracking-tight text-white md:text-6xl lg:text-7xl xl:text-8xl">
						Fee's & Tuition<span className="text-[#f9c04d]">.</span>
					</h2>
					<div className="mx-auto mt-10 grid w-full max-w-5xl grid-cols-1 justify-end gap-x-8 gap-y-8 sm:grid-cols-2 sm:gap-y-0">
						<div>
							<h3 className="text-2xl font-semibold tracking-widest text-[#f9c04d]">
								Registration Fees
							</h3>
							<ul>
								<li className="mt-4 text-base text-stone-200">
									Annual Student Registration Fee: $25.00
								</li>
								<li className="mt-4 text-base text-stone-200">
									Additional Family Member: $10.00
								</li>
							</ul>
							<h3 className="mt-8 text-2xl font-semibold tracking-widest text-[#f9c04d]">
								Tuition
							</h3>
							<ul>
								<li className="mt-4 text-base text-stone-200">
									30 Minute Class: $98 / 7 week session
								</li>
								<li className="mt-4 text-base text-stone-200">
									45 Minute Class: $119 / 7 week session
								</li>
								<li className="mt-4 text-base text-stone-200">
									60 Minute Class: $140 / 7 week session
								</li>
								<li className="mt-4 text-base text-stone-200">
									75 Minute Class: $154 / 7 week session
								</li>
								<li className="mt-4 text-base text-stone-200">
									90 Minute Class: $168 / 7 week session
								</li>
							</ul>
							<p className="py-6 text-stone-200">
								If enrolled in 4 or more classes, a family discount of 5% will
								be applied to total class fees. If enrolled in 8 or more
								classes, a family discount of 10% will be applied to total class
								fees.
							</p>
							<p className="text-stone-200">
								An additional 5% off class tuition will be applied when you
								choose to pay in full for all 5 sessions by October 1st. Please
								reach out to us at hello@stagedoordanceonline.com if you would
								like to set your account to{' '}
								<span className="font-bold">PAY IN FULL</span>.
							</p>
						</div>
						<div>
							<h3 className="text-2xl font-semibold tracking-widest text-[#f9c04d]">
								Tuition Policies
							</h3>
							<ul>
								<li className="mt-4 text-base font-bold italic text-stone-200">
									7 week Sessions
								</li>
								<li className="mt-4 text-base text-stone-200">
									<span className="font-bold text-[#f9c04d]">Session 1:</span>{' '}
									September 8 – October 26, 2026
								</li>
								<li className="mt-4 text-base text-stone-200">
									<span className="font-bold text-[#f9c04d]">Session 2:</span>{' '}
									October 27 – December 19, 2026
									<span className="block text-xs italic">
										Classes IN session Monday, Nov. 23, 2026
									</span>
									<span className="block text-xs italic">
										Fall Break - November 24 - 28, 2026
									</span>
									<span className="block text-xs italic">
										Holiday Break - December 20, 2026 - January 2, 2027
									</span>
								</li>
								<li className="mt-4 text-base text-stone-200">
									<span className="font-bold text-[#f9c04d]">Session 3:</span>{' '}
									January 4 – February 20, 2027
								</li>
								<li className="mt-4 text-base text-stone-200">
									<span className="font-bold text-[#f9c04d]">Session 4:</span>{' '}
									February 22 – April 17, 2027
									<span className="block text-xs italic">
										Spring Break - March 22 - 28, 2027
									</span>
								</li>
								<li className="mt-4 text-base text-stone-200">
									<span className="font-bold text-[#f9c04d]">Session 5:</span>{' '}
									April 19 – May 29, 2027
								</li>
							</ul>
							<p className="py-6 text-stone-200">
								<span className="font-bold">Our 35th Season</span> will run Our
								35th Season will run September 8, 2026- June 6, 2027. Upon
								initial online registration, a credit or debit card must be
								added to your account and processed for session 1 (or the
								current session) in order to secure your child’s spot in class.
								Payments are then processed by 7 week sessions. We will
								automatically charge your account the day before the next
								session begins.
							</p>
							<p className="text-stone-200">
								All dancers are automatically enrolled each session unless a
								class drop form is submitted. If you would like to withdraw your
								child from classes please complete a{' '}
								<a
									href="/class-drop-form.pdf"
									target="_blank"
									rel="noreferrer"
									className="text-[#FF80B5]"
								>
									class drop form{' '}
								</a>
								before the following session.
							</p>
							<p className="py-6 text-stone-200">
								No refunds, adjustments, transfers, or credits will be given for
								missed lessons. Make-up classes may be taken at any time during
								the dance season at a same or lower level class. In the event of
								studio closure due to inclement weather, make-up classes may be
								taken. In the event of studio closure due to global pandemic or
								any other reason forcing us to close for a period of time,
								classes will be offered via ZOOM.
							</p>
							<p className="text-stone-200">
								Stage Door Dance Academy accepts payments by cash, check, Visa,
								MasterCard, Discover, or AMEX. Please email us at
								hello@stagedoordanceonline.com if you would like to arrange an
								in-person payment by cash or check.
							</p>
						</div>
					</div>
				</div>
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
			</div>
			<div className="relative isolate overflow-hidden border-t-2 border-stone-800 bg-stone-900 pb-12">
				<div className="mx-auto max-w-7xl px-6 py-24 lg:px-8">
					<h2 className="text-center text-4xl font-bold tracking-tight text-white md:text-6xl">
						Learn about our <span className="text-[#f9c04d]">Programs</span>
					</h2>
					<div className="mt-10 flex items-center justify-center gap-x-6">
						<p className="text-lg leading-8 text-stone-200">
							We offer a variety of programs for dancers of all ages and skill.
						</p>
						<Link
							to="/class-definitions#programs"
							className="text-sm font-semibold leading-6 text-[#f9c04d]"
						>
							Learn more <span aria-hidden="true">→</span>
						</Link>
					</div>
				</div>
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
			</div>
		</main>
	)
}
